/* eslint-disable */
import { Provider } from 'react-redux'
import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { enableBatching } from 'redux-batched-actions'
import rootReducer from './reducers'
import applySagas from './sagas'
import LogRocket from 'logrocket'
import createSocketIoMiddleware from 'redux-socket.io'
import io from 'socket.io-client'
import { getApiUrlForEnv } from './utils/ApiUrl'

const sagaMiddleware = createSagaMiddleware()

const middlewares = [sagaMiddleware, LogRocket.reduxMiddleware()]

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { createLogger } = require('redux-logger')
  const logger = createLogger({
    collapsed: (getState, action, logEntry) => !logEntry.error,
    diff: false,
    diffPredicate: false,
  })

  middlewares.push(logger)
}

/* eslint-disable */
if (false /**getApiUrlForEnv(false) === 'https://api.bed-booking.com'**/) {
  const socket = io(
    `${getApiUrlForEnv(false)}:${process.env.REACT_APP_SOCKET_PORT || 3001}`,
  )
  const socketMiddleware = createSocketIoMiddleware(socket, 'socket/')

  middlewares.push(socketMiddleware)
}

const configureStore = () => {
  return createStore(
    enableBatching(rootReducer),
    compose(applyMiddleware(...middlewares)),
  )
}

export default configureStore()
export { Provider }

applySagas(sagaMiddleware)
